var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarArt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "main",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 790.1 1646.6",
    style: {
      enableBackground: "new 0 0 790.1 1646.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#2B3B97;stroke-miterlimit:22.9256;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#EBEBEC;stroke:#000000;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#000000;stroke-miterlimit:22.9256;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#6D6E70;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#EBEBEC;stroke:#2A3492;stroke-miterlimit:22.9256;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#EBEBEC;stroke:#231F20;stroke-miterlimit:10;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#EBEBEC;stroke:#000000;stroke-miterlimit:22.9256;}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#EBEBEC;stroke:#2B3B97;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#000000;stroke-miterlimit:10;}\n\t.st9{opacity:0.12;fill:#FF3B7C;enable-background:new    ;}\n\t.st10{opacity:0.1;fill:#FF3B7C;enable-background:new    ;}\n\t.st11{opacity:4.000000e-02;fill:#FF3B7C;enable-background:new    ;}\n\t.st12{fill:#FFFFFF;stroke:#FF3B7C;stroke-width:2.1804;stroke-miterlimit:4.9143;}\n\t.st13{fill:none;stroke:#FF3B7C;stroke-width:4;stroke-miterlimit:10;}\n\t.st14{fill:#FFFFFF;stroke:#000000;stroke-width:1.0408;stroke-miterlimit:10;}\n\t.st15{fill:none;stroke:#000000;stroke-width:1.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "car"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M694,561.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M399,1022.9c-95.8,0-106.8-9.1-165.1-16.1c-15.7-1.9-18.7,0.8-22.8,16.8c-4.1,16.1-21.6,90.2-29,121.3 s3.7,42.5,22,60.6c18.3,18.2,45.9,33.5,91.2,43.1c60,12.8,141.3,12.9,201.4,0c45.2-9.7,72.8-25,91.2-43.1 c18.3-18.2,29.5-29.6,22-60.6c-7.4-31.1-25-105.2-29-121.3c-4.1-16.1-7.1-18.7-22.8-16.8C499.7,1013.8,494.7,1022.9,399,1022.9 L399,1022.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M681.7,556.7L681.3,947c0,0,1.5,31.5,5.4,64.5s6.9,53.2,6.9,113.2c0,60.1-1,106.4-10.8,172.8 c-9.8,66.5-23.6,101.7-23.6,101.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M637,1140.4c-0.5,13,18.5,51.9,17.7,65c-6.4,97.5-26.9,169.7-38.2,205.6s-14.2,41.3-57.5,48.2 c-44.4,7.1-99.5,10.8-155,11.1c-60.9,0.4-122.3-3.3-170.9-11.1c-43.3-6.9-46.2-12.3-57.5-48.2c-11.3-35.9-31.8-108.1-38.2-205.6 c-1-15.2,18.1-50,17.7-65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M580.7,908c30.6,17,68.4,29.6,68.4,29.6s-0.1,8.1-0.9,30.5c-0.8,22.4-9.4,156.9-9.9,165.2 c-0.6,8.2-2.5,11.2-5.6,6.5c-3-4.7-5.1-8.1-14.3-30.8c-9.3-22.7-22.9-59.4-31.6-101.7C577.9,964.9,580.7,908,580.7,908L580.7,908z  M649.8,560.4c0,0-32.4,80.2-46.1,114.8c-13.7,34.6-18.5,54.4-20.9,113.2c-2.3,58.8-1.6,91-1.6,91c23.9,12,45,20.3,66.9,27.1 c0,0,4.7-260,5.2-292s1.6-43.8,1.8-52.4C655.3,553.6,656.4,545.8,649.8,560.4L649.8,560.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 581.2,
    y1: 879.4,
    x2: 580.7,
    y2: 908
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "656.7,538 667.5,559.2 658.9,588.5 638.2,584.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M665,581.4l-0.2,7.1l61.1,17c0,0,4.4-16-9.6-28.6s-33.2-19.3-42.6-21.7c-9.4-2.3-17.7,0.5-19.4,10.8 s1.3,12.4,4.2,13.3C661.3,580.3,665,581.4,665,581.4L665,581.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M398.7,665.8c-80.8,0-136.8,3.6-189.7,23.1c-18.2-44.3-34.2-86.2-50-130.5c-5.1-14.2-8.4-22-5.2-40.1 c3.2-18.1,36.9-37.6,78.3-51.5c41.5-13.8,98.4-24.5,161.6-24.5s124.6,10.8,166,24.6c41.4,13.9,75.1,33.3,78.3,51.5 c3.2,18.1-0.1,25.9-5.2,40.1c-15.8,44.3-31.8,86.2-50,130.5C529.9,669.5,479.5,665.8,398.7,665.8L398.7,665.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M132.8,1399.2c0,0,20.7,50,45.8,60.8s49.7,19.7,90.1,23.6s66.1,3.9,66.1,3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M110.2,552.2l0.4,394.8c0,0-1.5,31.5-5.4,64.5s-6.9,53.2-6.9,113.2c0,60.1,1,106.4,10.8,172.8 c9.8,66.5,23.6,101.7,23.6,101.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.2,908c0,0,2.8,56.9-6,99.2s-22.3,79-31.6,101.7c-9.3,22.7-11.3,26.1-14.3,30.8c-3,4.7-5,1.7-5.6-6.5 s-9.1-142.8-9.9-165.2c-0.8-22.4-0.9-30.5-0.9-30.5S180.6,925,211.2,908L211.2,908z M142.1,560.4c-6.6-14.6-5.5-6.9-5.3,1.7 c0.2,8.5,1.3,20.3,1.8,52.4c0.5,32,5.2,292,5.2,292c21.9-6.8,43-15.1,66.9-27.1c0,0,0.7-32.2-1.6-91s-7.1-78.6-20.9-113.2 C174.5,640.7,142.1,560.4,142.1,560.4L142.1,560.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 210.7,
    y1: 879.4,
    x2: 211.2,
    y2: 908
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "135.2,538 124.4,559.2 133,588.5 153.7,584.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M126.9,581.4l0.2,7.1l-61.1,17c0,0-4.4-16,9.6-28.6s33.2-19.3,42.6-21.7c9.4-2.3,17.7,0.5,19.4,10.8 s-1.3,12.4-4.2,13.3C130.6,580.3,126.9,581.4,126.9,581.4L126.9,581.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M659.1,1399.2c0,0-20.7,50-45.8,60.8s-49.7,19.7-90.1,23.6s-189.2,3.9-189.2,3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M135.2,538c0-0.8-2.4-50.3-2.5-51.1c-45.8-244.5,78.1-350.7,261.5-348.1c178.3,2.5,291.8,112.5,262.2,338.7 c-0.4,3.4,0,4.5-0.2,7c-0.9,12.3-1.4,57.4-0.9,57.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hood.outerline",
    className: "st8",
    d: "M681.7,557.6c0-25.6-2-48.7-2-58.7l9.3-121.3c5-159.7-122-271.2-271.2-271.2h-52.6 C216,106.4,85,219.5,93.9,377.6l15.2,115c0,10.7-0.4,30.6,1.1,59.6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarArt);
export default __webpack_public_path__ + "static/media/car-art.4010d2ee72e85392b4b993089330b52a.svg";
export { ForwardRef as ReactComponent };